import React, { Fragment } from 'react'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { Dialog } from 'primereact/dialog';
import { useFormik } from "formik";
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { useState } from 'react';
import { userService, roleService } from "../../services/extensions";
import properties from '../../config/environmentProperties';
import { useEffect } from 'react';

export default function UserReport() {


  const [filterDialog, setFilterDialog] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [newForm, setNewForm] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [filterObj, setFilterObj] = useState('');
  const [users, setUsers] = useState([]);

  const imgPath = properties.currentEnvironment.docPath + "images/";


  let count = 0;
  useEffect(() => {
    if (count == 0) { getUsers() }
    count++;
  }, []);

  const searchUser = (data) => {
    setShowButton(true);
    var dataObj = {};
    if (data.ecn !== "") {
      dataObj.ecn = data.ecn;
    }
    if (data.firstName !== "") {
      dataObj.firstName = data.firstName;
    }
    if (data.lastName !== "") {
      dataObj.lastName = data.lastName;
    }
    if (data.email !== "") {
      dataObj.email = data.email;
    }
    if (data.bu !== "") {
      dataObj.businessUnitId = data.bu;
    }
    let isClear = true;
    for (let v of Object.keys(data)) {
      if (data[v] != undefined && data[v] != '') {
        isClear = false
      }
    }
    if (isClear) { setShowMessage(false) }

    try {
      setFilterObj(dataObj);
      userService.userFilterReport(dataObj).then(
        (resp) => {
          if (resp.status === 200) {
            setUsers(resp.data.data);
            setShowButton(false);
            searchForm.resetForm();
            setFilterDialog(false);
          }
        },
        (error) => {
          setUsers();
          setShowButton(true);
        }
      );
    } catch (error) { }
  };


  const searchForm = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      ecn: "",
      phone: "",
      designation: "",
      bu: "",
      rm: ""
    },
    validate: (data) => {
      let errors = {};
      return errors;
    },
    onSubmit: (data) => {
      setShowMessage(true);
      searchUser(data);
      searchForm.resetForm();
    },
  });

  const isFormFieldValid = (name) =>
    !!(searchForm.touched[name] && searchForm.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{searchForm.errors[name]}</small>
      )
    );
  };

  const SearchForm = () => {
    return (
      <Fragment>
        <Dialog header="User Filter" visible={filterDialog} position="right" modal style={{ width: '500px' }}
          onHide={() => setFilterDialog(false)}
          draggable={false} resizable={false}>
          <form onSubmit={searchForm.handleSubmit}>
            <div className="grid p-fluid">
              <div className="col-6 field">
                <label htmlFor="firstName" className={classNames({ "p-error": isFormFieldValid("firstName"), })}>First Name</label>
                <span className="p-float-label">
                  <InputText name="firstName" value={searchForm.values.firstName} onChange={searchForm.handleChange} />
                </span>
              </div>
              <div className="col-6 field">
                <label htmlFor="lastName" className={classNames({ "p-error": isFormFieldValid("lastName"), })}>Last Name</label>
                <span className="p-float-label">
                  <InputText name="lastName" value={searchForm.values.lastName} onChange={searchForm.handleChange} />
                </span>
              </div>
              <div className="col-6 field">
                <label htmlFor="ecn" className={classNames({ "p-error": isFormFieldValid("ecn"), })}>ECN</label>
                <span className="p-float-label">
                  <InputText name="ecn" value={searchForm.values.ecn} onChange={searchForm.handleChange} />
                </span>
              </div>
              <div className="col-6 field">
                <label className={classNames({ "p-error": isFormFieldValid("email") })}>Email Address</label>
                <span className="p-float-label">
                  <InputText name="email" value={searchForm.values.email} onChange={searchForm.handleChange} />
                </span>
              </div>
              <div className="col-6 field">
                <label className={classNames({ "p-error": isFormFieldValid("bu") })}>Business Unit</label>
                <span className="p-float-label">
                  <InputText name="bu" value={searchForm.values.bu} onChange={searchForm.handleChange} />
                </span>
              </div>
            </div>
            <div className="col-12">
              <Button type="submit" icon="pi pi-search" label="Search" className="p-button-rounded filter_btn" />
            </div>
          </form>
        </Dialog>
      </Fragment>
    );
  };


  const getUsers = () => {
    userService.userFilterReport().then((resp) => {
      setUsers(resp.data.data);
    });
  };

  const tableHeader = () => {
    return (
      <Fragment>
        <div className="grid">
          <div
            className="col mt-3 mb-2"
            style={{ paddingLeft: "25px", paddingRight: "21px" }}
          >
            <span className="heading">
              User's List
              <div className="heading-actions">
                <Button icon="pi pi-replay" className="p-button-rounded p-button-help p-button-text" aria-label="Replay" onClick={() => { setFilterObj(''); getUsers() }} />
                <Button icon="pi pi-filter" className="p-button-rounded p-button-help p-button-text" aria-label="Filter" onClick={() => setFilterDialog(true)} />
              </div>
            </span>
          </div>
        </div>
      </Fragment>
    );
  };
  const allocatedProjec = (item) => {
    return (
        item.projects.map((item)=>{
          return <div>{item}</div> 
        })
    );}

  const imageBodyTemplate = (item) => {
    return (
      <div className="flex align-items-center gap-2">
        {item?.photo === "" || item?.photo === null ? (
          <span className="photo-span profile-icon-text capitalize">
            {item.firstName.substr(0, 1)}
            {item.lastName.substr(0, 1)}
          </span>
        ) : (
          <img style={{
            height: "40px", width: "40px", borderRadius: "50%", border: "3px solid #d7e9ff", Top: "16px", bottom: "16px", left: "16px",
          }}
            src={imgPath + item?.photo || ""}
            alt=""
          />
        )}
        <div>{item.firstName + " " + item.lastName}</div>
      </div>
    );
  };

  return (
    <div>
      {SearchForm()}
      <DataTable
        value={users}
        header={tableHeader}
        paginator
        responsiveLayout="scroll"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        rows={10}
        rowsPerPageOptions={[10, 20, 50]}
        editMode="row"
      >
        <Column field="ecn" header="ECN" sortable></Column>
        <Column field="" header="Name" body={imageBodyTemplate} className="initCap" sortable></Column>
        <Column field="email" header="Email Address" sortable></Column>
        <Column field="" header="Allocated Project" body={allocatedProjec} sortable></Column>
        <Column field="designation" header="Designation"  style={{ minWidth: "12rem" }} sortable></Column>
        <Column field="businessUnitId" header="BU"  style={{ minWidth: "5rem" }} sortable></Column>
      </DataTable>
    </div>
  )
}